import { css } from "lit"

export const storeFooterStyles = css`
  /* Store footer */
  .store-footer {
    background: white;
    border-top: 1px solid #e5e7eb;
  }

  .store-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4rem 1.25rem;
    text-align: center;
  }

  .store-icon {
    width: 1.5rem;
    height: 1.5rem;
    fill: #f59e0b;
    margin-bottom: 1.5rem;
  }

  .store-title {
    font-size: 1.5rem;
    font-family: Georgia, serif;
    color: #1f2937;
    margin-bottom: 1.5rem;
  }

  .store-text {
    max-width: 28rem;
    color: #4b5563;
    font-size: 0.875rem;
    line-height: 1.8;
  }

  .store-text a {
    color: #2563eb;
  }
`